/* 布局 */
//前台
import Layout from "@views/layout";

const teaopenclassRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "teaopenclass/list",
        name: "TEAOPENCLASS",
        meta: {
            title: "教师公开课",
        },
        component: () => import("@views/business/teaopenclass/index.vue"),
    },
        ],
};

export default teaopenclassRouter;
